// extracted by mini-css-extract-plugin
export default {"list":"Select-module__list___BbsdY"};